import styled, { css } from "styled-components";
import queries, { devices, minQuery } from "utils/responsivenessHelper";
import { fonts } from "assets/fontStyles";
import colours from "assets/colours";
import { menuWidth, headerHeight } from "constants/layout";
import zIndex from "constants/zIndex";

const Container = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  min-height: ${headerHeight};
  right: 0px;
  top: 0px;

  background: #fdfdfe;
  box-shadow: 0px 4px 24px #ebeef3;
  padding: 0px 35px;

  ${queries.both({
    width: "100vw",
    left: "0",
    right: "unset",
    height: "auto",
    boxShadow: "none",
    background: colours.white,
  })}

  z-index: ${zIndex.header};

  ${({ mobile, navOpen }) => {
    if (!mobile && navOpen)
      return css`
        width: calc(100% - ${menuWidth});
      `;
  }}
`;

const HamburgerIcon = styled.img`
  display: none;
  ${queries.both({
    display: "flex",
    maxWidth: "36px",
  })}

  ${minQuery.both(
    {
      maxWidth: "46px",
    },
    null,
    devices.iPad
  )}
`;

const Logo = styled.img`
  cursor: pointer;
  ${queries.both({
    display: "flex",
    height: "50px"
  })}

  ${minQuery.both(
    {
      display: "flex",
      height: "50px"
    },
    null,
    devices.iPad
  )}
`;

const Heading = styled.div`
  ${fonts.heading5};
  margin-left: 0.6em;

  ${queries.both({
    fontSize: "1.25rem",
    margin: "0em",
  })}

  ${minQuery.both(
    {
      fontSize: "1.5rem",
    },
    null,
    devices.iPad
  )}
`;

const HeaderRightContent = styled.div`
  display: flex;
  margin-left: auto;
  ${queries.both(
    {
      background: colours.white,
      width: "100%",
      margin: "0 auto",
      display: "flex",
      justifyContent: "center",
      padding: "20px 0px",
      boxShadow: "0px 4px 24px #ebeef3",
    },
    devices.mobile
  )}
`;

export { Container, HamburgerIcon, Logo, Heading, HeaderRightContent };
